import type { BaseType } from '@martech-solution/utils/types';

export interface IHRTicketCategory extends BaseType {
  id: number;
  code: string;
  name: string;
  nameEn: string;
  effectiveFromDate?: Date;
  effectiveToDate?: Date;
  isActive: boolean;
  linkedTypes?: string;
  isRemovable: boolean;
}

export type HrTicketCategoryAdd = Omit<
  Partial<IHRTicketCategory>,
  'id' | 'isRemovable' | 'createdDate' | 'lastModifiedDate'
>;

export enum HRTicketCategoryEn {
  PURCHASE_REQUEST = 'PR',
  PURCHASE_QUOTATION_REQUEST = 'PQR',
  PURCHASE_QUOTATION = 'PQ',
  PURCHASE_ORDER = 'PO',
  GOOD_RECEIPT_PO_REQUEST = 'GRPOR',
  GOOD_RECEIPT_PO = 'GRPO'
}
